<script lang="ts" setup>
type Props = {
  isDesktop?: boolean
}

const props = defineProps<Props>()

const imageSrc = props.isDesktop ? '/logo/logo.svg' : '/logo/logo-mobile.svg'
</script>

<template>
  <nuxt-link to="/" class="header-logo">
    <nuxt-img :src="imageSrc" alt="Логотип компании Фарфор" />
  </nuxt-link>
</template>

<style lang="scss" scoped>
.header-logo {
  display: block;
  width: 28px;
  height: 28px;

  @include media('>=desktop-mini') {
    width: 146px;
    height: 36px;
  }

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
